import type { Media, Task } from 'src/services/apollo/generated/graphql'
import { fetchGetMedia } from 'src/services/apollo/media'
import invariant from 'src/utils/invariant'
import { getPublicUrl } from 'src/utils/media'
import { getMediaIdsFromTask } from 'src/utils/task'
import { toastAwaitAll } from 'src/utils/toast'
import {
  type AssetId,
  type EditorAsset,
  type EditorStore,
  createAssetId,
} from '../editor-core'

export function generateAssetIdFromMedia(
  store: EditorStore,
  media: Media,
): AssetId {
  const url = getPublicUrl(media)
  invariant(url, 'Media has no url')

  const assetId = createAssetId(media.id)

  const asset: EditorAsset = {
    id: assetId,
    name: 'Generated Image ' + assetId,
    src: url,
    width: media.width ?? 0,
    height: media.height ?? 0,
    mimeType: media.imageType || 'image/png',
    meta: {
      mediaId: media.id,
      media,
    },
  }

  store.createAsset(asset)

  // Preload the image
  new Image().src = url

  return assetId
}

export async function generateAssetIdsFromTask(
  store: EditorStore,
  task: Task,
): Promise<AssetId[]> {
  const medias = await toastAwaitAll(
    'Loading images...',
    getMediaIdsFromTask(task).map(id => fetchGetMedia({ id })),
  )

  return medias
    .map(res => res.data?.media)
    .filter(media => media != null)
    .map(media => generateAssetIdFromMedia(store, media))
}
